import { customerApi } from "../../utils/apiConfig";

export const diningHallCleaningPlanInsert = (payload) => {
  return customerApi.post("/diningHallCleaningPlanInsert", payload, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const getPersonels = () => {
  return customerApi.get("/getPersonelForPlan", {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const diningHallCleaningPlanUpdate = (payload) => {
  return customerApi.post("/diningHallCleaningPlanUpdate", payload, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const diningHallCleaningPlanDelete = (payload) => {
  return customerApi.post("/diningHallCleaningPlanDelete", payload, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const diningHallCleaningPlanList = (payload) => {
  return customerApi.post("/diningHallCleaningPlanList", payload, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};
